import React from 'react';
import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap';
import {toastr} from 'react-redux-toastr';

import SubmitButton from '../../Forms/ItSkillForm/SubmitButton.jsx';
import Modal from "../Modal.jsx";
import ItSkillForm from "../../Forms/ItSkillForm/ItSkillForm.jsx";

export default class ItSkillModal extends Modal {
  onSubmitSuccess = () => {
    const action = (this.props.offset !== undefined) ?
      'modifiée' : 'créée';
    toastr.success(`L'outil ' a été ${action} avec succès.`);
  }

  onSubmit = (values) => {
    const {freelance} = this.props;
    const itSkills = this.props.freelance?.it_skills?.length ? this.props.freelance.it_skills : [];
    if (this.props.offset !== undefined) {
      itSkills[this.props.offset] = values;
    } else {
      itSkills.push(values);
    }

    if (this.props.onSubmit) {
      this.props.onSubmit({freelance: {...freelance, it_skills: itSkills}});
    }

    if (this.props.onClose) {
      this.props.onClose(itSkills);
    }

    this.props.closeModal();
  }

  render() {
    if (!this.props.freelance) {
      return null;
    }
    const itSkills = (this.props.offset !== undefined && this.props.freelance.it_skills[this.props.offset]) || null;

    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} className="mission-modal modal-lg">
        <ModalHeader toggle={this.props.closeModal}>Outils</ModalHeader>
        <ModalBody>
          <ItSkillForm
            onSubmitSuccess={this.onSubmitSuccess}
            initialValues={itSkills}
            onSubmit={this.onSubmit}
          />
          <div className="text-center">
            <SubmitButton className="btn btn-primary my-3">
              Enregistrer
            </SubmitButton>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}
